<template>
  <b-card title="حساب های کل و معین">
    <b-button variant="success" href="#/addTopic">جدید</b-button>
    <!-- <div v-for="item in getList" v-bind:key="item.id">
      <topicItem v-bind:list="list" v-bind:item="item"></topicItem>
    </div> -->
    <v-treeview open-all hoverable :items="list"></v-treeview>
  </b-card>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../../helpers/httpHelper";
import topicItem from "./topicItem";
export default {
  name: "TopicList",
  data() {
    return {
      list: [],
    };
  },
  components: {
    topicItem,
  },
  methods: {
    createList(list, parent_id) {
      var l = [];
      var all = list.filter(function (o) {
        return o.parent_id == parent_id;
      });
      all.forEach((element) => {
        l.push({
          id: element.id,
          name: "(" + element.code + ") " +  element.name + ' - (id: ' + element.id+')',
          children: this.createList(list, element.id),
        });
      });
      return l;
    },
  },
  created() {
    httpHelper.getData("acctopic").then((res) => {
      //console.log(res);
      this.list = this.createList(res.result, null);
      console.log(this.list);
    });
  },
  computed: {
    getList() {
      if (this.list) {
        return this.list.filter(function (item) {
          return item.parent_id == null;
        });
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "حساب های کل و معین" }]);
  },
};
</script>